import { MediaFile } from "./media.model";

class Material {
  constructor(
    public id: string = "",
    public name: string = "",
    public description: string = "",
    public type: any = null,
    public priority: number = 0,
    public content: any[] = [],
    public file?: any,
    public concluded?: boolean,
    public done?: boolean,
    public liked?: boolean,
    public skipped?: boolean,
    public learningGroupType?: any,
    public lessons?: any,
    public stoppedAt: number = 0,
    public firstClosure: boolean = false,
    public firstMotivation: boolean = false,
    public expectedConclusionTime?: any,
    public index?: number,
    public createdAt?: string,
    public learningObjectiveId?: string
  ) {}
}

class MaterialType {
  public static readonly ESSENTIAL = "ESSENTIAL";
  public static readonly COMPLEMENTARY = "COMPLEMENTARY";
}

class MaterialLearningGroupType {
  public static readonly INTRODUCTION = "INTRODUCTION";
  public static readonly MOTIVATION = "MOTIVATION";
  public static readonly DEVELOPMENT = "DEVELOPMENT";
  public static readonly CLOSURE = "CLOSURE";
}
class ConfigModal {
  public showMaterials = false;
  public maxIndexMaterial = 0;
  public typeModalHeader = "TEACHER";
  public currentIndex = 0;
}

class TypeModalHeader {
  public static readonly ADMINISTRATOR = "ADMINISTRATOR";
  public static readonly TEACHER = "TEACHER";
  public static readonly TEACHER_TRADITIONAL_COURSE =
    "TEACHER_TRADITIONAL_COURSE";
  public static readonly STUDENT_LEARNING_MAP = "STUDENT_LEARNING_MAP";
  public static readonly STATS_LEARNING_MAP = "STATS_LEARNING_MAP";
  public static readonly TEACHER_LINEAR = "TEACHER_LINEAR";
}

export {
  Material,
  MaterialType,
  MaterialLearningGroupType,
  ConfigModal,
  TypeModalHeader,
};
